var APPLICATION_STRATEGY_MAP, APPLICATION_STRATEGY_OPTIONS, CONSTANT_FIELDS, OrganizationFormModel;

APPLICATION_STRATEGY_MAP = {
  '审核后加入': 'must_approved',
  '自动加入': 'auto_approved',
  '禁止申请': 'closed'
};

APPLICATION_STRATEGY_OPTIONS = _.map(APPLICATION_STRATEGY_MAP, function(_val, key) {
  return {
    id: Skylark.Helpers.Utilities.uuid(),
    isOtherOption: false,
    value: key,
    _destroy: false
  };
});

CONSTANT_FIELDS = [
  {
    id: -1,
    title: '组织名称',
    type: 'Field::TextField',
    validations: ["presence"],
    settings: {
      layout: null
    },
    _editing: true
  },
  {
    id: -2,
    title: '成员加入策略',
    type: 'Field::RadioButton',
    validations: ["presence"],
    settings: {
      layout: "select"
    },
    _editing: true,
    options: APPLICATION_STRATEGY_OPTIONS
  }
];

import RichTextEditor from 'trunks/vue/admin/components/libs/richtext_editor.js';

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import FieldList from 'trunks/vue/admin/components/response_fields/list/fieldable.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

export default OrganizationFormModel = Vue.extend({
  components: {
    'editor': RichTextEditor,
    'modal': Modal,
    'field-list': FieldList
  },
  props: {
    prosfileFields: {
      type: Array,
      required: true
    },
    editOrganizationEditorExtendClass: {
      type: [String, Array]
    },
    action: {
      type: String
    },
    organization: {
      type: Object
    },
    parent: {
      type: Object
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: function() {
    var ref;
    return {
      valid: true,
      description: (ref = this.organization) != null ? ref.description : void 0
    };
  },
  computed: {
    basicAttributefields: function() {
      return _.map(CONSTANT_FIELDS, (item) => {
        return this._createTypeField(item);
      });
    },
    basicAttributeResponse: function() {
      var default_strategy_option, ref, ref1;
      default_strategy_option = ((ref = this.organization) != null ? ref.application_strategy : void 0) ? _.find(APPLICATION_STRATEGY_OPTIONS, (option) => {
        return this.organization.application_strategy === APPLICATION_STRATEGY_MAP[option.value];
      }) : _.first(APPLICATION_STRATEGY_OPTIONS);
      return new Skylark.App.Model.Response({
        id: '_organization_basic_attributes_response',
        entries: [
          {
            field_id: -1,
            value: (ref1 = this.organization) != null ? ref1.name : void 0
          },
          {
            field_id: -2,
            value: default_strategy_option.value,
            option_id: default_strategy_option.id
          }
        ]
      });
    },
    profileResponse: function() {
      var ref;
      return new Skylark.App.Model.Response(_.extend({
        id: '_organization_profile_response'
      }, (ref = this.organization) != null ? ref.profile_submission : void 0));
    },
    showProfileFields: function() {
      if (this.action === 'edit_profile') {
        return true;
      }
    },
    showDescription: function() {
      if (this.action === 'edit_description') {
        return true;
      }
    }
  },
  template: `<modal :title='title' ref="modal" :extendClass='"responses-import-modal organization-modal"'>
  <div class="modal-body">
    <field-list :fields='basicAttributefields'
                :response='basicAttributeResponse'
                :entries='basicAttributeResponse.entries'
                :editing='true'
                extendClass='field-list-two-item'
                v-show='!showProfileFields && !showDescription'
                ref='basicAttributesRef' />

    <editor :customClass="['description-editor', editOrganizationEditorExtendClass]"
            :value='description'
            :menuSticky='false'
            @valueChanged='valueChanged'
            placeholder='请输入组织简介'
            v-show='!showProfileFields'
            ref='editor' />

    <field-list :fields='prosfileFields'
                :response='profileResponse'
                :entries='profileResponse.entries'
                :editing='true'
                v-show='!showDescription'
                ref='prosfileRef' />
  </div>
  <template slot="footer">
    <div class="modal-footer">
      <button class="outlined btn-default" @click='close'>取消</button>
      <button @click='onEnsure'>确定</button>
    </div>
  </template>
</modal>`,
  methods: {
    valueChanged: function(value) {
      this.description = value;
      return this.$emit('descriptionChanged', value);
    },
    onEnsure: function() {
      var basicValue, organization_attributes, prosfileSchemaValue, ref;
      basicValue = this.$refs.basicAttributesRef.getEntries();
      prosfileSchemaValue = this.$refs.prosfileRef.getEntries();
      if (!this.$refs.basicAttributesRef.valid) {
        return;
      }
      if (!this.$refs.prosfileRef.valid) {
        return;
      }
      organization_attributes = _.extend(this._dumpBasicValue(basicValue), {
        parent_id: (ref = this.parent) != null ? ref.id : void 0,
        profile_submission_attributes: {
          entries_attributes: prosfileSchemaValue
        },
        description: this.description
      });
      return this.$emit('valueChange', organization_attributes);
    },
    open: function() {
      return this.$refs.modal.open();
    },
    close: function() {
      return this.$refs.modal.close();
    },
    resetModal: function() {
      this.$refs.basicAttributesRef.reset();
      this.$refs.prosfileRef.reset();
      return this.$refs.editor.clearContent();
    },
    _createTypeField: function(item) {
      return Skylark.App.Model.Field.Base.new(item, void 0, {});
    },
    _dumpBasicValue: function(value) {
      return _.reduce(value, function(memo, item) {
        switch (item.field_id) {
          case -1:
            memo.name = item.value;
            break;
          case -2:
            memo.application_strategy = APPLICATION_STRATEGY_MAP[item.value];
        }
        return memo;
      }, {});
    }
  }
});
